// removed by extract-text-webpack-plugin
module.exports = {"home-title":"src-components-home-title----HomeTitle-module---home-title---3jqPp","role":"src-components-home-title----HomeTitle-module---role---2_uaW","logo-container":"src-components-home-title----HomeTitle-module---logo-container---3ZFsl","logo":"src-components-home-title----HomeTitle-module---logo---1NjUb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/title/HomeTitle.module.scss
// module id = 301
// module chunks = 213534597649335